import api from "./api";

export function find() {
  return new Promise((resolve, reject) => {
    api
      .get("/email-delivery-configuration")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function merge(values) {
  return new Promise((resolve, reject) => {
    api
      .put("/email-delivery-configuration", values)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function testConnection(data) {
  return new Promise((resolve, reject) => {
    api
      .post("/email-delivery-configuration/test-connection", data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}
